import { render, staticRenderFns } from "./WaterArea.vue?vue&type=template&id=043ad3f8&scoped=true&"
import script from "./WaterArea.vue?vue&type=script&lang=js&"
export * from "./WaterArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043ad3f8",
  null
  
)

export default component.exports